import { Component, Input } from '@angular/core'

@Component({
  selector: 'dmmp-card-horizontal-image-link',
  templateUrl: './card-horizontal-image-link.component.html'
})
export class CardHorizontalImageLinkComponent {
  @Input() image
  @Input() text
  @Input() link
  @Input() identifier
}
